define('Components/ProductListWidget/js/models/MediaProductListWidgetInstanceModel',['jquery','Components/ProductListWidget/js/models/ProductListWidgetInstanceModel','app'],function($,ProductListWidgetInstanceModel,app){
    return ProductListWidgetInstanceModel.extend({
        getImage: function(suffix,format){

            suffix = this.p('imageformat') ? this.p('imageformat').suffix : false;
            format = this.p('imageformat') ? this.p('imageformat').extension : false;

            suffix = suffix ? suffix : '1920x1080';
            format = format ? format : 'JPG';

            var id_picture = this.p('image'),
                baseline = this.get('baseline'),
                url = app.getPictureUrl(id_picture,'Widget',suffix,format,baseline);

            return url || false;
        },
        getVideo: function(){
            if(this.p('videourl') && this.p('videourl') != ''){
                return app.getThemeUrl()+'medias/videos/strat1.mp4';
            }else{
                return false;
            }
        },
        isAnimated: function(){
            return this.p('is_animated') == "1" && this.getMaxPerPage() == 4;
        },
        getBaseline: function(){
            var self = this,
                html = $('<div>' + self.p('baseline') + '</div>');
            if(html.find('p').length <= 0){
                html.wrapInner('<p><span></span></p>');
            }
            if(html.find('span').length <= 0){
                html.find('p').wrapInner('<span></span>');
            }
            return html.html();
        },
        getMaxPerPage:function(){
            var view = this;
            var max = Math.min(Math.max(view.getProductsSize(), 2), 6);
            if(max % 2 != 0){ max++; }
            return max;
        }

    })
})
;
